// utils/phone-format.js

/**
 * Formats a parsed libphonenumber-js object in national style,
 * preserving any user-entered leading zeros.
 *
 * @param {string} raw - The user-entered string (what the user typed)
 * @param {object} phoneNumber - Parsed phone number object from libphonenumber-js
 * @returns {string} - Formatted number that keeps the user's leading zero behavior
 */
export function formatNationalKeepLeadingZero(raw: any, phoneNumber: any) {
  if (!raw || !phoneNumber) return raw

  const userTypedZero = raw.trim().startsWith('0')
  let formatted = phoneNumber.formatNational()

  // Compare only digits
  const formattedDigits = formatted.replace(/\D/g, '')

  // If user typed zero but library removed it
  if (userTypedZero && !formattedDigits.startsWith('0')) {
    formatted = formatted.replace(/^(\d)/, '0 $1')
  }

  // If library added zero but user didn't type one
  if (!userTypedZero && formattedDigits.startsWith('0')) {
    formatted = formatted.replace(/^0\s?/, '')
  }

  // Fallback (in case the library produces empty)
  if (!formatted) {
    formatted = raw.replace(/(\d{3})(?=\d)/g, '$1 ')
  }

  return formatted.trim()
}
